import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { CalendarGridBodyProps } from "reka-ui"
import { CalendarGridBody } from "reka-ui"


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarGridBody',
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CalendarGridBody), _mergeProps({ "data-slot": "calendar-grid-body" }, props), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})